import { type DocumentVariableMetadata, documentVariableGroup } from './document-variable'

/**
 * Ubicación de la negociación (objeto `place` → país / departamento / municipio).
 *
 * Los tres son `enum`: son catálogos acotados, así el condicional ofrece igual/distinto con la
 * lista para elegir. El `value` de cada opción es el NOMBRE que resuelve el orquestador (no el
 * código), para que la comparación coincida.
 *
 * ☠️ Y por eso los tres llevan `optionsFromHost`: esas listas se derivan de `countries.json`,
 * `departments-gt.json` y `municipalities-gt.json` —170 KB de geografía que viven en el bundle de
 * la web—. Copiarlas acá sería la segunda fuente de verdad; arrastrar los JSON las metería en el
 * bundle de la API a cambio de nada.
 */

export const LUGAR_VARIABLE_METADATA: DocumentVariableMetadata[] = documentVariableGroup({
  prefix: 'lugar',
  category: 'negotiation',
  groupLabel: 'Ubicación',
  fields: {
    pais: {
      label: 'Ubicación · País',
      type: 'enum',
      optionsFromHost: true,
      example: 'Guatemala'
    },
    departamento: {
      label: 'Ubicación · Departamento',
      type: 'enum',
      optionsFromHost: true,
      example: 'Guatemala'
    },
    municipio: {
      label: 'Ubicación · Municipio',
      type: 'enum',
      optionsFromHost: true,
      example: 'Mixco'
    }
  }
})
